import type { SVGProps } from 'react'

const Filter = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3.5" y="5" width="13" height="1.5" rx="0.75" fill="currentColor" />
      <rect x="6" y="9" width="7.5" height="1.5" rx="0.75" fill="currentColor" />
      <rect x="7.5" y="13" width="4.5" height="1.5" rx="0.75" fill="currentColor" />
    </svg>
  )
}

export default Filter
